module.exports = "https://www.gc-qa.gnp.com.mx/184c794fbb5eceb7eda0b3e7597f1488.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow_forward_ios_24px.svg
// module id = 8061
// module chunks = 0